export default __webpack_public_path__ + "static/media/boiler-big.2dd11778.png";